import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Accordion, { AccordionGroup } from 'src/components/Elements/Accordion';
import styles from './styles.scss';

const Faq = ({ className, titleStyle = '', title = 'Frequently Asked', items, itemStyle = '' }) => (
  <div className={className}>
    {title && <h3 className={cn('n900 marginBottom-small2', titleStyle, styles.title)}>{title}</h3>}
    <AccordionGroup>
      {items.map((f) => (
        <Accordion key={f.id} title={f.questionText} className={cn('padding-small1', itemStyle)}>
          <div className={cn('p1 n900', styles.text)}>{f.answerText}</div>
        </Accordion>
      ))}
    </AccordionGroup>
  </div>
);

Faq.propTypes = {
  className: PropTypes.string,
  titleStyle: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      questionText: PropTypes.any,
      answerText: PropTypes.any,
    }),
  ),
  itemStyle: PropTypes.string,
};

export default memo(Faq);
